module.exports = __webpack_public_path__ + "static/media/2_en.8e856dd7.png";